import {useQuery} from 'react-query';

import getSearchStoresByNumber from '.';

const useGetSearchStoresByNumber = (phone_number: string) => {
  const {data, isLoading, refetch} = useQuery(
    [
      'get-search-stores-by-number',
      phone_number?.replace(/^0/, '98 ').replace(/\s/g, ''),
    ],
    getSearchStoresByNumber,
    {enabled: phone_number?.length === 11 ? true : false},
  );

  return {storeData: data, isLoading, refetchStoreList: refetch};
};

export default useGetSearchStoresByNumber;
